import { apiRequest } from './auth'

type Envelope<T> = { data: T; meta: { requestId: string; version?: number } }

export async function getPreference<T>(key: string): Promise<T | null> {
  const response = await apiRequest<Envelope<T>>(`me/preferences/${encodeURIComponent(key)}`)
  return response.meta.version ? response.data : null
}

export async function savePreference<T>(key: string, value: T): Promise<void> {
  await apiRequest(`me/preferences/${encodeURIComponent(key)}`, {
    method: 'PUT',
    body: JSON.stringify({ value }),
  })
}
